export default [
   

    // {
    //     path: '/home/report',
    //     name: 'homeReport',
    //     meta: {
    //         pageTitle: '我要申请',
    //         bgColor: '#f8f8f8'
    //     },
    //     component: () => import('@/views/home/report')
    // },

    {
        path: '/home/query',
        name: 'HomeIndex',
        meta: {
            pageTitle: '质保期查询',
            bgColor: '#f8f8f8'
        },
        component: () => import('@/views/home/query')
    },

    // {
    //     path: '/home/verification',
    //     name: 'homeVerification',
    //     meta: {
    //         pageTitle: '我要核销',
    //         bgColor: '#f8f8f8'
    //     },
    //     component: () => import('@/views/home/verification')
    // },
    // {
    //     path: '/my/profile',
    //     name: 'myProfile',
    //     meta: {
    //         pageTitle: '个人信息',
    //         bgColor: '#f8f8f8'
    //     },
    //     component: () => import('@/views/my/profile')
    // },
    {
        path: '/customer/list',
        name: 'customerList',
        meta: {
            pageTitle: '客户信息列表',
            bgColor: '#f8f8f8'
        },
        component: () => import('@/views/customer/list')
    },

    {
        path: '/customer/add',
        name: 'customerAdd',
        meta: {
            pageTitle: '添加客户信息',
            bgColor: '#f8f8f8'
        },
        component: () => import('@/views/customer/add')
    },

    {
        path: '/home/main',
        name: 'homeMain',
        meta: {
            pageTitle: '好友留言',
            bgColor: '#f8f8f8'
        },
        component: () => import('@/views/home/main')
    },
    
    {
        path: '/my/order',
        name: 'myOrder',
        meta: {
            pageTitle: '奥威亚',
            bgColor: '#f8f8f8'
        },
        component: () => import('@/views/my/order')
    },
    {
        path: '/my/bind',
        name: 'myBind',
        meta: {
            pageTitle: '绑定手机',
            bgColor: '#f8f8f8',
            needWxuser: false
        },
        component: () => import('@/views/my/bind')
    },
    {
        path: '/my/workOrder',
        name: 'myWorkOrder',
        meta: {
            pageTitle: '创建工单',
            bgColor: '#f8f8f8',
            needWxuser: false
        },
        component: () => import('@/views/my/workOrder')
    },
    // {
    //     path: '/',
    //     name: 'HomePage',
    //     meta: {
    //         pageTitle: '首页',
    //         bgColor: '#f8f8f8'
    //     },
    //     component: () => import('@/views/home/main')
    // },
    {
        path: '/my-order/list',
        name: 'qrcode',
        meta: {
            pageTitle: '我的订单'
        },
        component: () => import('@/views/my-order/list')
    },
    {
        path: '/my/orderInfo',
        name: 'orderInfo',
        meta: {
            pageTitle: '详情'
        },
        component: () => import('@/views/my/orderInfo')
    },
    {
        path: '/article/category',
        name: 'articleCategory',
        meta: {
            pageTitle: '服务政策'
        },
        component: () => import('@/views/article/category')
    },
    {
        path: '/article/list',
        name: 'articleList',
        meta: {
            pageTitle: '政策列表'
        },
        component: () => import('@/views/article/list')
    },
    {
        path: '/article/detail',
        name: 'articleDetail',
        meta: {
            pageTitle: '政策详情'
        },
        component: () => import('@/views/article/detail')
    },
    {
        path: '/my/deviceInformation',
        name: 'deviceInformation',
        meta: {
            pageTitle: '设备信息'
        },
        component: () => import('@/views/my/deviceInformation')
    },
/**
 * 阿金 yyh5 
 */
    {
        path: '/',
        name: 'HomeIndex',
        meta: {
            pageTitle: '预约',
            bgColor: '#FFFFFF'
        },
        component: () => import('@/views/home/index')
    },

    {
        path: '/declare/index',
        name: 'declareIndex',
        meta: {
            pageTitle: '我要申请',
            bgColor: '#f8f8f8'
        },
        component: () => import('@/views/declare/index')
    },
    
    {
        path: '/declare/declareOk',
        name: 'declareOk',
        meta: {
            pageTitle: '申请结果',
            bgColor: '#f8f8f8'
        },
        component: () => import('@/views/declare/declareOk')
    },


    {
        path: '/my/index',
        name: 'myIndex',
        meta: {
            pageTitle: '我的',
            bgColor: '#f8f8f8'
        },
        component: () => import('@/views/my/index')
    },

    {
        path: '/home/application',
        name: 'homeApplication',
        meta: {
            pageTitle: '我要申报',
            bgColor: '#FFFFFF'
        },
        component: () => import('@/views/home/application')
    },

    {
        path: '/home/AddOk',
        name: 'HomeAddOk',
        meta: {
            pageTitle: '申报结果',
            bgColor: '#FFFFFF'
        },
        component: () => import('@/views/home/AddOk')
    },

    {
        path: '/ercode/hexiao',
        name: 'Hexiao',
        meta: {
            pageTitle: '核销',
            bgColor: '#FFFFFF'
        },
        component: () => import('@/views/ercode/hexiao')
    },

    {
        path: '/ercode/hexiaoXq',
        name: 'HexiaoXq',
        meta: {
            pageTitle: '详情',
            bgColor: '#FFFFFF'
        },
        component: () => import('@/views/ercode/hexiaoXq')
    },

    {
        path: '/ercode/hexiaoList',
        // name: 'HexiaoList',
        meta: {
            pageTitle: '核销记录',
            bgColor: '#f8f8f8'
        },
        component: () => import('@/views/ercode/hexiaoList')
    },

    {
        path: '/my/qrcode',
        name: 'myQrcode',
        meta: {
            pageTitle: '我的二维码',
            bgColor: '#f8f8f8'
        },
        component: () => import('@/views/my/qrcode')
    },

    {
        path: '/my/profile',
        name: 'myProfile',
        meta: {
            pageTitle: '个人资料',
            bgColor: '#f8f8f8'
        },
        component: () => import('@/views/my/profile')
    },

    {
        path: '/my/wdsb',
        name: 'myWdsb',
        meta: {
            pageTitle: '我的申报',
            bgColor: '#f8f8f8'
        },
        component: () => import('@/views/my/wdsb')
    },


    {
        path: '/my/sbjl',
        name: 'mySbjl',
        meta: {
            pageTitle: '申请记录',
            bgColor: '#f8f8f8'
        },
        component: () => import('@/views/my/sbjl')
    },

    {
        path: '/ercode/test',
        name: 'scanTest',
        meta: {
            pageTitle: '扫码',
            bgColor: '#f8f8f8'
        },
        component: () => import('@/views/ercode/test')
    },


    

]